import {} from '@splitsoftware/splitio-react';

export const splitSDKConfig: SplitIO.IBrowserSettings = {
  core: {
    authorizationKey: 'fm4ur66cflc3lt0jjrh6j3olsu0iebp4ji1j',
    // key represents your internal user id, or the account id that
    // the user belongs to.
    // This could also be a cookie you generate for anonymous users.
    key: 'key',
  },
};
